export class BaseDTO {
  created: Date | number;
  createdBy: string;
  tenantId: number;
  updated: Date | number;
  updatedBy: string;
}
